import { render, staticRenderFns } from "./AvartarField.vue?vue&type=template&id=7004aeb0&"
import script from "./AvartarField.vue?vue&type=script&lang=js&"
export * from "./AvartarField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports